import styled from 'styled-components';

export const DivFullList = styled.div`
  width: 250px;
`;
